<script lang="ts">
    import {pipe} from 'core/utils'
    import type {Loan} from 'typings/portaro.be.types';
    import KpDocumentMini from '../../record/kp-document-mini/KpDocumentMini.svelte';
    import {getDateFormatter} from 'core/svelte-context/context';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let loan: Loan;
    export let showLoanCount = false;

    const dateFormatter = getDateFormatter();
</script>

<div class="loan-document-mini">
    <KpDocumentMini document="{loan.document}" exemplar="{loan.exemplar}"/>

    {#if showLoanCount && loan.chunkable && loan.quantity > 0}
        <IconedContent icon="book-alt" justify="start">
            <div>Vypůjčeno {loan.quantity} kusů</div>
        </IconedContent>
    {/if}

    {#if (loan.timeslotOccupations ?? []).length > 0}
        <IconedContent icon="time-delete" justify="start">
            <div class="time-occupations-container">
                {#each loan.timeslotOccupations as timeslotOccupation(timeslotOccupation.id)}
                    <div>{pipe(timeslotOccupation.dateRange.fromDate, dateFormatter('d.M. HH:mm'))} - {pipe(timeslotOccupation.dateRange.toDate, dateFormatter('d.M. HH:mm'))}</div>
                {/each}
            </div>
        </IconedContent>
    {/if}
</div>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    .loan-document-mini {
        display: flex;
        flex-direction: column;
        gap: @padding-large-vertical;
    }
</style>